var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"loading":_vm.loading},on:{"click":_vm.initSort}},[_vm._v("Start")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }